// Tema central del estudio: paleta wellness (crema, beige, verde sage)
const theme = {
  colors: {
    bg: '#FAF7F2',
    surface: '#FFFFFF',
    sand: '#F0EAE0',
    sandDark: '#E4DDD1',
    sage: '#7C8B76',
    sageDark: '#5C6B57',
    sageDeep: '#46523F',
    sageLight: '#E9EEE6',
    text: '#2F2C27',
    textMuted: '#6F6A61',
    border: '#E4DDD1',
    danger: '#B4544A',
    dangerLight: '#F7E8E6',
    success: '#4F7A5B',
    successLight: '#E6F0E9',
    warning: '#A87932',
    warningLight: '#F7EEDD',
  },
  fonts: {
    heading: "'Lora', Georgia, serif",
    body: "'Raleway', 'Segoe UI', sans-serif",
  },
  space: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2.5rem',
    xxl: '4rem',
  },
  radii: {
    sm: '8px',
    md: '14px',
    lg: '22px',
    pill: '999px',
  },
  shadows: {
    sm: '0 1px 3px rgba(47, 44, 39, 0.08)',
    md: '0 6px 24px rgba(47, 44, 39, 0.09)',
    lg: '0 16px 48px rgba(47, 44, 39, 0.12)',
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
  },
  maxWidth: '1120px',
};

export default theme;
